var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconVisibilityOff(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-visibility-off",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.415,1.949A16.484,16.484,0,0,0,14.342.444,1.167,1.167,0,0,0,12.6.339l-3.5,3.5a4.575,4.575,0,0,1,.07,2.578A4.691,4.691,0,0,1,5.79,9.8a4.575,4.575,0,0,1-2.578-.07L.342,12.6a1.172,1.172,0,0,0,.385,1.913,10.757,10.757,0,0,0,3.873.723A11.3,11.3,0,0,0,10.538,13.5a15.665,15.665,0,0,0,4.935-5.063A6.744,6.744,0,0,0,15.415,1.949Z",
    transform: "translate(9.4 8.762)",
    fill: "#222227"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M5.693.98.98,5.693A3.385,3.385,0,0,1,0,3.337,3.343,3.343,0,0,1,3.337,0,3.385,3.385,0,0,1,5.693.98Z",
    transform: "translate(10.664 10.664)",
    fill: "#222227"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M18.958,2.707,15,6.662a4.65,4.65,0,0,0-3.337-1.377,4.719,4.719,0,0,0-3.337,8.05L4.387,17.29H4.375a16.664,16.664,0,0,1-3.5-3.978,6.733,6.733,0,0,1,0-6.638A15.579,15.579,0,0,1,5.728,1.738,11.4,11.4,0,0,1,11.667,0,11.592,11.592,0,0,1,18.958,2.707Z",
    transform: "translate(2.334 4)",
    fill: "#222227"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M3.535.2A3.343,3.343,0,0,1,.2,3.535.578.578,0,0,1,0,3.512L3.512,0A.578.578,0,0,1,3.535.2Z",
    transform: "translate(13.802 13.801)",
    fill: "#222227"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M23.059.262a.9.9,0,0,0-1.272,0L.262,21.8a.9.9,0,0,0,0,1.272.923.923,0,0,0,.63.257.884.884,0,0,0,.63-.268L23.059,1.522A.867.867,0,0,0,23.059.262Z",
    transform: "translate(2.339 2.338)",
    fill: "#222227"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Vector-6",
    "data-name": "Vector",
    d: "M0,0H28V28H0Z",
    transform: "translate(28 28) rotate(180)",
    fill: "none",
    opacity: 0
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVisibilityOff);
export default __webpack_public_path__ + "static/media/icon-visibility-off.7d1c53d7a84128c96a58be867529deb1.svg";
export { ForwardRef as ReactComponent };